<script>
import EmptyStateBlock from '@/components/general/empty-state-block.vue'
import InfoLabel from '@/components/general/info-label.vue'
import UserAvatar from '@/components/user/user-avatar.vue'
import GradeList from '@/components/booking/grade-list.vue'
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BookingDetailsTabDetails',
  components: {
    UserAvatar,
    InfoLabel,
    EmptyStateBlock,
    GradeList,
  },
  mixins: [baseMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    certifications() {
      return this.booking.details.certifications
    },
    hasCertifications() {
      return this.certifications.length > 0
    },
    grades() {
      return this.booking.details.grades
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="$t('booking.details.info.coveringLabel')">
      <div class="d-flex align-center mt-2">
        <UserAvatar size="sm" :name="booking.details.covering.name" />
        <div class="ml-2">
          <p class="mb-0 font-weight-medium">{{
            booking.details.covering.name
          }}</p>
          <p class="mb-0 caption">{{ booking.details.covering.reason }}</p>
        </div>
      </div>
    </InfoLabel>

    <InfoLabel :label="$t('booking.details.info.gradesLabel')" class="mt-6">
      <GradeList :grades="grades"></GradeList>
    </InfoLabel>

    <InfoLabel :label="$t('booking.details.info.notesLabel')" class="mt-6">
      <p
        v-sanitized-html="booking.details.notes"
        class="mb-0 font-weight-medium"
      ></p>
    </InfoLabel>

    <InfoLabel
      v-if="booking.details.room"
      :label="$t('booking.details.info.roomLabel')"
      class="mt-6"
    >
      <p
        v-sanitized-html="booking.details.room"
        class="mb-0 font-weight-medium"
      ></p>
    </InfoLabel>

    <EmptyStateBlock
      v-if="!hasCertifications"
      class="mt-6"
      border
      icon="mdi-file-document-alert"
      :title="$t('booking.details.info.certifications.emptyTitle')"
      :description="$t('booking.details.info.certifications.emptyDescription')"
    />
    <InfoLabel
      v-else
      class="mt-6"
      :label="$t('booking.details.info.certifications.label')"
    >
      <v-simple-table fixed-header height="300px">
        <template v-slot>
          <tbody>
            <tr v-for="item in certifications" :key="item.name">
              <td class="d-flex align-center"
                ><p class="mb-0 font-weight-medium">{{ item.name }}</p></td
              >
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </InfoLabel>
  </div>
</template>
